module.exports = __webpack_public_path__ + "static/img/142_phase_function_Paper_Points.dae6dcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/142_phase_function_Paper_Points.png
// module id = PaiG
// module chunks = 0